import { Component } from 'react';
import logger from '@widgets/logger';
import ErrorPage from '@pages/Error';
import SentryManager from '@widgets/sentry-manager';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        logger.error('ErrorBoundary error: ', error);
        logger.error('ErrorBoundary info:', errorInfo);

        SentryManager.captureException(error, {
            context: 'ErrorBoundary',
            errorInfo: JSON.stringify(errorInfo),
            location: window.location.href,
            component: errorInfo.componentStack,
        });
        if (!this.state.hasError) {
            this.setState({ hasError: true });
        }
    }

    render() {
        if (this.state.hasError) {
            return <ErrorPage />;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
